export const responseTimeout = 'Server is taking too long to respond. Please try again later.';
export const internetConnectionProblem =
  'There is an internet connection problem, please try again later.';
export const somethingWentWrong = 'Something went wrong. Please try again later.';
export const pleaseFixFieldBeforeSubmit = 'Please fix all invalid field before submit';
export const forbiddenAccess = 'forbidden';
